<div class="account-management">
  <div class="account-management__table-wrapper">
    <div class="account-management__summary">
      <span>{{ 'account.admin.totalAccounts' | transloco: { count: accounts().length } }}</span>
      <span>{{ 'account.admin.onlineNow' | transloco: { count: onlineCount() } }}</span>
      <button eBtn size="sm" color="highlight" icon="rotate" [loading]="isLoading()" (click)="loadAccounts()">
        {{ 'account.admin.refresh' | transloco }}
      </button>
    </div>

    <e-advanced-table class="dock-y" [items]="accounts()" [headers]="headers" [loading]="isLoading()">
      <ng-container eTableColumn="isVerified">
        <ng-template eTableCell let-item="item">
          @if (item.isVerified) {
            <i class="fa-solid fa-circle-check text-success" [title]="item.verifiedOn | dateTimeFormat: 'standard'"></i>
          } @else {
            <i class="fa-solid fa-circle-xmark text-danger"></i>
          }
        </ng-template>
      </ng-container>

      <ng-container eTableColumn="lastLoginOn">
        <ng-template eTableCell let-item="item">
          @if (item.lastLoginOn) {
            {{ item.lastLoginOn | dateTimeFormat: 'standard' }}
          } @else {
            <span class="text-muted">—</span>
          }
        </ng-template>
      </ng-container>

      <ng-container eTableColumn="activeSessionCount">
        <ng-template eTableCell let-item="item">
          @if (item.activeSessionCount > 0) {
            <span class="account-management__online-dot" aria-hidden="true"></span>
          }
          {{ item.activeSessionCount }}
        </ng-template>
      </ng-container>

      <ng-container eTableColumn="createdOn">
        <ng-template eTableCell let-item="item">
          {{ item.createdOn | dateTimeFormat: 'standard' }}
        </ng-template>
      </ng-container>

      <ng-container eTableColumn="accountCreatedByMethod">
        <ng-template eTableCell let-item="item">
          {{ 'account.admin.createdByMethod.' + item.accountCreatedByMethod | transloco }}
        </ng-template>
      </ng-container>

      <ng-container eTableRow>
        <ng-template eTableRowMenu let-item="item">
          @if (!item.isVerified) {
            <e-dropdown-menu-item icon="user-check" iconColor="success" (click)="onAdminVerify(item)">
              {{ 'account.admin.actions.verify' | transloco }}
            </e-dropdown-menu-item>
          }
          <e-dropdown-menu-item icon="key" (click)="onTriggerPasswordReset(item)">
            {{ 'account.admin.actions.sendReset' | transloco }}
          </e-dropdown-menu-item>
          @if (item.activeSessionCount > 0) {
            <e-dropdown-menu-item icon="sign-out-alt" iconColor="danger-75" (click)="onForceLogout(item)">
              {{ 'account.admin.actions.forceLogout' | transloco }}
            </e-dropdown-menu-item>
          }
          <e-dropdown-menu-item icon="user-slash" iconColor="danger" (click)="onDeactivate(item)">
            {{ 'account.admin.actions.deactivate' | transloco }}
          </e-dropdown-menu-item>
        </ng-template>
      </ng-container>
    </e-advanced-table>
  </div>
</div>
